import { Box, Stack, styled, Tab } from '@mui/material';
import { DEFAULT_BACKGROUND_IMAGE_URL } from '@provision/membership-plans-ui';

export const CONFIG_PANEL_INITIAL_WIDTH_PX = 400;
export const CONFIG_PANEL_MIN_WIDTH_PX = 350;
export const CONFIG_PANEL_MAX_WIDTH_PX = 550;
const PREVIEW_MAX_WIDTH_PX = 400;
const LAYOUT_HEADER_OFFSET_PX = 120;

export const MembershipsConfigContainer = styled(Stack)(({ theme }) => ({
  flexGrow: 1,
  height: `calc(100vh - ${theme.typography.pxToRem(LAYOUT_HEADER_OFFSET_PX)})`,
  position: 'relative',
  flexDirection: 'row',
}));

export const PreviewContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'backgroundImageUrl',
})<{ backgroundImageUrl?: string }>(({ backgroundImageUrl }) => ({
  flex: 1,
  minWidth: 0,
  overflow: 'auto',
  overflowX: 'hidden',
  backgroundImage: `url(${backgroundImageUrl || DEFAULT_BACKGROUND_IMAGE_URL})`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundAttachment: 'scroll',
  position: 'relative',
  width: '100%',
  height: '100%',
  minHeight: 0,
}));

export const PreviewContent = styled(Stack)(({ theme }) => ({
  position: 'relative',
  zIndex: 10,
  alignItems: 'center',
  justifyContent: 'flex-start',
  minHeight: 'min-content',
  width: '100%',
  paddingTop: theme.spacing(4),
  paddingBottom: 0,
  boxSizing: 'border-box',
}));

interface ConfigPanelProps {
  customWidth: number;
}

export const ConfigPanel = styled(Stack, {
  shouldForwardProp: (prop) => prop !== 'customWidth',
})<ConfigPanelProps>(({ theme, customWidth }) => ({
  width: theme.typography.pxToRem(customWidth),
  minWidth: theme.typography.pxToRem(CONFIG_PANEL_MIN_WIDTH_PX),
  maxWidth: theme.typography.pxToRem(CONFIG_PANEL_MAX_WIDTH_PX),
  flexShrink: 0,
  height: '100%',
  overflow: 'hidden',
}));

export const PanelHeader = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  borderBottom: `${theme.typography.pxToRem(1)} solid ${theme.palette.divider}`,
}));

export const PanelContent = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.custom.OV.sys.surfaceContainerLowest,
  flex: 1,
  overflow: 'auto',
}));

export const PanelFooter = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: `${theme.typography.pxToRem(1)} solid ${theme.palette.divider}`,
}));

export const PreviewPlaceholder = styled(Stack)(({ theme }) => ({
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  padding: theme.spacing(4),
  color: theme.palette.common.white,
  maxWidth: theme.typography.pxToRem(PREVIEW_MAX_WIDTH_PX),
  margin: '0 auto',
}));

export const MembershipsConfigTab = styled(Tab)(({ theme }) => ({
  textTransform: 'none',
  fontSize: theme.typography.pxToRem(14),
  fontWeight: 500,
  color: theme.palette.custom.OV.sys.onSurface,
  minHeight: theme.typography.pxToRem(48),
  '&.Mui-selected': {
    color: theme.palette.custom.OV.sys.primary,
  },
}));

export const PanelTitle = styled('div')(({ theme }) => ({
  fontSize: theme.typography.pxToRem(12),
  fontWeight: 600,
  color: theme.palette.text.secondary,
  letterSpacing: '0.1em',
  textTransform: 'uppercase',
}));
